export default __webpack_public_path__ + "static/media/erreurs_tréso.1d832dd0.jpg";